import { TIcons } from '@yuno/design-system-web'

export type AllowedTypes = {
  payment: boolean
  enrollment: boolean
}

export type WebhookDrawerProps = {
  open: boolean
  onSuccess?: () => void
  onClose: () => void
  payload?: any
  webhooksList: any
  onError?: () => void
}

export type DeleteWebhookProps = Pick<WebhookDrawerProps, 'onSuccess'>

export type CreateWebhookProps = {
  onClose: () => void
  allowedTypes?: AllowedTypes
  setError?: React.Dispatch<
    React.SetStateAction<{
      isError: boolean
      isGeneric: boolean
    }>
  >
}

export type EditWebhookProps = Pick<
  WebhookDrawerProps,
  'onSuccess' | 'payload' | 'onError'
>

export enum EWebhookStatus {
  active = 'ACTIVE',
  inactive = 'INACTIVE',
}

export const actionsNames = [
  'enrollment_triggers',
  'payment_triggers',
  'report_triggers',
  'customer_triggers',
]

export enum EEnrollmentTriggers {
  enroll = 'ENROLL',
  unenroll = 'UNENROLL',
}

export enum EPaymentTriggers {
  capture = 'capture',
  authorize = 'authorize',
  cancel = 'cancel',
  expiration = 'expiration',
  refund = 'refund',
  verify = 'verify',
  purchase = 'purchase',
}

export enum EReportTriggers {
  create = 'create',
  update = 'update',
}

export enum ICustomerTriggers {
  create = 'create',
  update = 'update',
}

export type TTriggers = {
  id: string
  name: string
}

export type TWebhook = {
  id: number
  name: string
  state: EWebhookStatus
  url: string
  api_key: string
  secret: string
  created_at?: string
  updated_at?: string
  enrollment_triggers?: Array<TTriggers>
  payment_triggers?: Array<TTriggers>
  report_triggers?: Array<TTriggers>
  customer_triggers?: Array<TTriggers>
  account_code: string
}

export type TWebhookHelpers = {
  status: EWebhookStatus
}
export type WebhookFormFormOptionalFields = {
  id:
    | 'NAME'
    | 'ENDPOINT_URL'
    | 'API_KEY'
    | 'SECRET'
    | 'ENROLLMENT'
    | 'PAYMENT'
    | 'REPORT'
    | 'CUSTOMER'
  order: number
  name: string
  description: string
  max_length: number
  type: string
  options: Array<TTriggers>
  description_language_code?: string
  name_language_code?: string
  value?: string | Array<Object>
}

export type TDrawerMessages = {
  icon?: TIcons
  title: string
  subtitle: string
  paramSubtitle?: string
  color?: string
}

type TTableColumn = {
  label: string
}

type TTableRow = {
  label: string
  value: string
}

export type TTableResponsive = {
  columnsTable: TTableColumn[]
  isLoading: boolean
  rows: TTableRow[]
  onCopied: () => void
  setMessageSnack?: (value: string) => void
  title: string
  subtitle?: string
  withCopy: boolean
  withShow: boolean
  allowed?: boolean
  needPassword?: boolean
}
